import ProgressBar from '@/components/base/ProgressBar';
import type { RoleHeadcount } from '@/utils/staff';

interface RoleCoveragePanelProps {
  rows: RoleHeadcount[];
  total: number;
}

export default function RoleCoveragePanel({ rows, total }: RoleCoveragePanelProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <header className="flex items-center justify-between gap-2 border-b border-background-200 px-5 py-4">
        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950">
            Access by role
          </h3>
          <p className="mt-0.5 text-xs text-foreground-500">Active users per role</p>
        </div>
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-base text-primary-700">
          <i className="ri-shield-user-line" />
        </span>
      </header>
      <ul className="divide-y divide-background-100">
        {rows.map(({ role, count }) => (
          <li key={role.id} className="px-5 py-3.5">
            <div className="flex items-center justify-between gap-3">
              <span className="text-sm text-foreground-900">{role.name}</span>
              <span className="text-sm font-medium text-foreground-950">
                {count}
                <span className="ml-1 text-xs font-normal text-foreground-400">
                  /{total}
                </span>
              </span>
            </div>
            <ProgressBar
              className="mt-2"
              value={total > 0 ? (count / total) * 100 : 0}
              tone={
                role.id === 'admin' ? 'primary' : role.id === 'finance' ? 'accent' : 'secondary'
              }
            />
          </li>
        ))}
      </ul>
    </section>
  );
}